module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.a7b29440.svg";